// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Guernsey */
const GG = /^(?:7(?:(?:781|839)\d|911[17])\d{5})$/;

export default GG;
